import { service } from '@ember/service';
import type { AccountExtension as AccountModel } from 'tio-data/data/resources/account.ext';
import Component from '@glimmer/component';
import type RouterService from 'tio-employee/services/router';
import { t } from 'ember-intl';
import { Section } from 'tio-ui/components/layout';
import PageHeader from 'tio-ui/components/page-header';
import SyfAccountLinked from 'tio-employee/components/syf/account-linked';

interface SyfLinkingConfirmationRouteSignature {
  Args: {
    model: AccountModel;
  };
}

export class SyfLinkingConfirmationRouteComponent extends Component<SyfLinkingConfirmationRouteSignature> {
  @service declare router: RouterService;

  didConfirm = () => {
    this.router.transitionTo('authenticated.syf.account-confirmation');
  };

  <template>
    <PageHeader @a11yTitle={{t "account_linking.default"}} @sticky={{false}} />
    <Section>
      <:body>
        <SyfAccountLinked @account={{@model}} @onConfirmation={{this.didConfirm}} />
      </:body>
    </Section>
  </template>
}
